import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { SellerSalesSummary } from "@models/seller-sales-summary";
import { TableModule } from "primeng/table";
import { DialogHeaderComponent } from "../../../../../../shared/components/dialog-header/dialog-header.component";
import { PaymentMethodPipe } from "../../../../../shared/pipes/payment-method.pipe";

interface SellerPaymentMethodDetail {
  payment_method: string;
  revenue: number;
  tickets_count: number;
}

@Component({
  selector: "app-seller-payment-method-details-dialog",
  imports: [
    CommonModule,
    MatDialogModule,
    TableModule,
    DialogHeaderComponent,
    PaymentMethodPipe,
  ],
  templateUrl: "./seller-payment-method-details-dialog.component.html",
  styleUrl: "./seller-payment-method-details-dialog.component.scss",
})
export class SellerPaymentMethodDetailsDialogComponent {
  readonly details: SellerPaymentMethodDetail[];
  readonly totalTickets: number;
  readonly totalRevenue: number;

  constructor(@Inject(MAT_DIALOG_DATA) readonly data: SellerSalesSummary) {
    this.details = Object.entries(data.by_payment_method).map(
      ([paymentMethod, summary]) => ({
        payment_method: paymentMethod,
        revenue: summary.revenue,
        tickets_count: summary.tickets_count,
      }),
    );
    this.totalTickets = this.details.reduce(
      (total, detail) => total + detail.tickets_count,
      0,
    );
    this.totalRevenue = this.details.reduce(
      (total, detail) => total + detail.revenue,
      0,
    );
  }
}
